'use client'
import { useStore } from '@/store'
import {
  getProductShippingStatusDetailText,
  getProductShippingStatusText,
} from './copy'
import {
  getCountryDisplayName,
  normalizeCountryIsoCode,
} from '@/countryDisplay'
import { isEuropeanCountry } from '@/lib/middleware/variantRedirect.helper'
import { useStorefrontMarket } from '@/useStorefrontMarket'

export const ShippingStatus = () => {
  const cachedCountry = useStore(state => state.country)
  const countryFreeShippingStatus = useStore(
    state => state.countryFreeShippingStatus
  )
  const { countryIsoCode: country } = useStorefrontMarket({
    cachedCountryIsoCode: cachedCountry,
  })
  const freeShippingStatus =
    normalizeCountryIsoCode(cachedCountry) === normalizeCountryIsoCode(country)
      ? countryFreeShippingStatus
      : null
  const text = getProductShippingStatusText(country, freeShippingStatus)

  if (!text) return null
  const countryName = getCountryDisplayName(country) || country.toUpperCase()
  const isEuropean = isEuropeanCountry(country)

  return (
    <div className="mt-3 rounded-md border border-green-200 bg-green-50 p-3 text-sm text-green-900">
      <div className="text-base font-bold leading-5">{text}</div>
      {isEuropean && (
        <div className="mt-1 text-green-800">
          {getProductShippingStatusDetailText(country, countryName)}
        </div>
      )}
    </div>
  )
}
